module.exports = __webpack_public_path__ + "static/media/masse.c5e8c27c.mp3";